import React, { useState } from 'react';
import './CloseCompanyModal.css';

const CloseCompanyModal = ({ isOpen, onClose, companyName, onConfirm, loading, error }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
      setPassword('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    onConfirm(password);
    setPassword('');
  };

  const handleClose = () => {
    onClose();
    setPassword('');
  };

  return (
    <div className="close-company-modal-overlay" onClick={handleBackdropClick}>
      <div className="close-company-modal-content">
        <div className="close-company-modal-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h3 className="close-company-modal-title">Close company</h3>
        <p className="close-company-modal-message">
          To close <strong>{companyName}</strong>, enter your current account password to confirm. You will receive an email confirmation with company details.
        </p>
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="close-company-modal-error">{error}</div>
          )}
          <label className="close-company-modal-label">
            Current password
            <div className="close-company-modal-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="close-company-modal-input"
                autoComplete="current-password"
                disabled={loading}
              />
              <button
                type="button"
                className="close-company-modal-toggle-password"
                onClick={() => setShowPassword((s) => !s)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                )}
              </button>
            </div>
          </label>
          <div className="close-company-modal-actions">
            <button
              type="button"
              className="close-company-modal-btn cancel"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="close-company-modal-btn confirm"
              disabled={loading || !password.trim()}
            >
              {loading ? <span className="spinner small"></span> : 'Close company'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CloseCompanyModal;
